module.exports = __webpack_public_path__ + "media/images/components/c02-page-footer/wave-7e517b73343facf8bce0602cc60d2676.svg";